import css from 'styled-jsx/css';

export const styles = css`
  .BigProductCardShareDropdown {
    position: absolute;
    top: 39px;
    right: 7px;
    z-index: 1;
    width: 234px;
    background-color: #fff;
    box-shadow: 0px 18px 23px 0px #00000011;
    border: 1px solid var(--colors-brandLightGrey1);
    border-radius: 3px;
  }

  .BigProductCardShareDropdown:before {
    content: '';
    position: absolute;
    top: -9px;
    right: 7px;
    display: inline-block;
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 0px 5.5px 8px 5.5px;
    border-color: transparent transparent var(--colors-brandLightGrey1) transparent;
  }

  .BigProductCardShareDropdown::after {
    content: '';
    position: absolute;
    top: -7px;
    right: 7px;
    display: inline-block;
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 0px 5.5px 8px 5.5px;
    border-color: transparent transparent #fff transparent;
  }

  .BigProductCardShareDropdown__list {
    list-style: none;
    padding: 0;
    margin: 0;
  }

  .BigProductCardShareDropdown__item {
    padding: 10px 15px;
    font-size: 14px;
    color: var(--colors-doveGray);
    cursor: pointer;
    display: flex;
    align-items: center;
  }

  .BigProductCardShareDropdown__ItemImage {
    width: 20px;
    text-align: center;
    margin-right: 8px;
  }

  .BigProductCardShareDropdown__item:hover {
    background-color: var(--colors-brandLightGrey5);
  }
`;
